<template>
  <div id="ecommerce_product">
    <div v-if="state == 'list'">
      <v-container>
        <div>
          <v-layout wrap>
            <v-flex xs12 sm12 class="form-control pa-2 text-xs-center text-sm-right">
              <input
                type="text"
                class="form-control ma-0"
                v-model="search"
                style="display: inline-block; max-width: 300px"
                :placeholder="$t('Search')"
              />
              <!-- v-if="categorylist && categorylist.length > 0 && productlist.length > 0" -->

              <!-- <transfer-shop style="display: inline-block"></transfer-shop> -->
            </v-flex>
          </v-layout>
        </div>
        <template v-if="loadingCategory">
          <div style="padding: 30px 0">
            <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
          </div>
        </template>
        <template v-else-if="categorylist && categorylist.length == 0">
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 230px" />
              <h3 class="headline">{{ $t('create your first category') }}</h3>
              <p>{{ $t('Click Add Category to create a category and add products') }}</p>
              <v-btn color="primary" depressed @click="showCategory = true">
                <em class="fa fa-plus middle mr-1" />
                {{ $t('Add new categories') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <div>
            <v-layout wrap>
              <v-flex xs5>
                <h3 class="headline mt-2">{{ $t('Member Level') }}</h3>
              </v-flex>
              <v-flex xs7 text-xs-right>
                <v-btn small fab outline class="primary--text" @click="showCategory = true">
                  <em class="fa fa-pencil-alt middle" />
                </v-btn>
              </v-flex>
            </v-layout>
            <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
              <filter-category
                :categories="categorylist"
                v-model="currentCategory"
                @onChangeCategory="onChangeCategory"
                :stat="filterBadge"
              ></filter-category>
            </div>
          </div>
          <v-divider class="mb-2"></v-divider>
          <div>
            <template v-if="loadingSubCategory">
              <div style="padding: 30px 0">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <template v-else>
              <v-layout wrap>
                <v-flex xs12 text-xs-left v-if="!subcategorylist">
                  <v-btn color="primary" class="ma-2 white--text" @click="showSubCategory = true">
                    <em class="fa fa-plus" />
                    <span class="pl-2">Add New Sub Category</span>
                  </v-btn>
                </v-flex>
                <template v-else-if="currentCategory !== 'all'">
                  <v-flex xs9 text-xs-left>
                    <filter-category
                      :categories="subcategorylist"
                      v-model="currentSubCategory"
                      @onChangeSubCategory="onChangeSubCategory"
                      :hasAll="false"
                      :stat="filterBadge"
                    ></filter-category>
                  </v-flex>
                  <v-flex xs3 text-xs-right>
                    <v-btn small fab outline class="primary--text" @click="showSubCategory = true">
                      <em class="fa fa-pencil-alt middle" />
                    </v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </template>
          </div>
          <v-divider class="mb-3"></v-divider>
          <!-- Products -->
          <div>
            <!-- v-if="currentCategory && currentCategory != null" -->
            <template>
              <v-layout warp>
                <v-flex xs12 sm6>
                  <h3 class="headline mt-3">{{ $t('Products') }}</h3>
                </v-flex>
                <v-flex xs12 sm6 class="text-xs-right">
                  <v-btn outline color="primary" @click="showSortProduct = true">
                    <v-icon class="mr-2">swap_vert</v-icon>
                    {{ $t('sort product') }}
                  </v-btn>
                  <sort-product
                    v-if="showSortProduct"
                    v-model="showSortProduct"
                    :key="timestamp"
                    @onChangeProduct="onChangeProduct"
                  ></sort-product>
                </v-flex>
              </v-layout>

              <template v-if="!loadingProduct">
                <v-layout wrap v-if="categorylist && filterProducts && filterProducts.length > 0">
                  <v-flex xs12 sm1>
                    <v-select
                      :items="pagelimit"
                      solo
                      v-model="size"
                      @change="onChangeLimit"
                      small
                      class="browser-default mb-2"
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                    <v-pagination
                      v-model="pageNumber"
                      :length="pageCount"
                      @input="onClickPageinate"
                      class="mb-2"
                    ></v-pagination>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm6 md4 lg3 xl2 class="pa-1">
                    <div
                      class="btn-add"
                      @click="onAddNewProduct"
                      style="position: relative; min-height: 360px; cursor: pointer; height: 100%"
                    >
                      <div
                        style="position: absolute; top: 50%; margin-top: -30px; left: 0; right: 0"
                      >
                        <div class="text-xs-center">
                          <h3 class="headline" style="color: #969595">
                            <em class="fa fa-plus" />
                          </h3>
                          <p>{{ $t('Add new product') }}</p>
                        </div>
                      </div>
                      <template
                        v-if="
                          ($store.getters.getPackage != 'premium' || isCoachlab) &&
                          productlist.length >= maxProduct
                        "
                      >
                        <v-premium-plan-popup
                          :showAll="false"
                          marginTop="65"
                          :size="'small'"
                        ></v-premium-plan-popup>
                      </template>
                    </div>
                  </v-flex>
                  <template v-if="categorylist && filterProducts && filterProducts.length > 0">
                    <template v-for="(product, index) in filterProducts">
                      <v-flex xs12 sm6 md4 lg3 xl2 class="pa-1" :key="'product_' + product.id">
                        <product
                          @changeproductstatus="onChangeProductStatus"
                          v-model="filterProducts[index]"
                          @productDeleted="onDeleteProduct(index)"
                          :category="categorylist"
                          :selectCategory="currentCategory"
                          :page="'gift'"
                          @onSelectedProduct="onSelectedProduct(index, product)"
                        ></product>
                      </v-flex>
                    </template>
                  </template>
                </v-layout>

                <v-layout
                  wrap
                  v-if="categorylist && filterProducts && filterProducts.length > 0"
                  class="mt-3"
                >
                  <v-flex xs12 sm1>
                    <v-select
                      :items="pagelimit"
                      solo
                      v-model="size"
                      @change="onChangeLimit"
                      small
                      class="mb-2"
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                    <v-pagination
                      v-model="pageNumber"
                      :length="pageCount"
                      @input="onClickPageinate"
                      class="mb-2"
                    ></v-pagination>
                  </v-flex>
                </v-layout>
              </template>
              <template v-else>
                <div style="padding: 30px 0">
                  <scale-loader
                    :color="$vuetify.theme.primary"
                    height="45px"
                    width="7px"
                  ></scale-loader>
                </div>
              </template>
              <div class="mb-5 mt-5"></div>
            </template>
          </div>
        </template>

        <!-- Gift Category -->
        <gift-category
          v-model="categorylist"
          @close="showCategory = false"
          :show="showCategory"
          @onCategoryChange="onCategoryChange"
          @deleteCategory="deleteCategory"
        ></gift-category>

        <!-- Gift Subcategory -->
        <gift-sub-category
          v-model="subcategorylist"
          @close="showSubCategory = false"
          :show="showSubCategory"
          :categorylist="categorylist"
          @onSubCategoryChange="onSubCategoryChange"
        ></gift-sub-category>
      </v-container>
    </div>
    <div v-else-if="state == 'add-product'">
      <template v-if="categorylist && state == 'add-product'">
        <v-container>
          <modal-gift
            :categorylist="categorylist"
            @onAddProduct="addProduct"
            @close="close"
          ></modal-gift>
        </v-container>
      </template>
    </div>
    <div v-else-if="state == 'edit-product'">
      <template v-if="categorylist && currentProduct">
        <v-container>
          <modal-gift
            :editData="currentProduct"
            :categorylist="categorylist"
            @onSaveProduct="closeEditProduct"
            @close="close"
          ></modal-gift>
        </v-container>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './Product'
import SelectCategory from '@/components/view/template/ecommerce/SelectCategory'
import FilterCategory from './FilterCategory.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import GiftCategory from './GiftCategory'
import GiftSubCategory from './GiftSubCategory'
import ModalHelp from '@/components/elements/ModalHelp'
import TransferShop from '@/components/view/template/ecommerce/TransferShop.vue'
import SortProduct from '@/components/view/template/ecommerce/SortProduct.vue'
import moment from 'moment'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import ImportShop from '@/components/view/template/ecommerce/ImportShop.vue'
import ModalGift from './ModalGift.vue'
import XLSX from 'xlsx'

import api from '@/api'

export default {
  data: function () {
    return {
      showSortProduct: false,
      pageNumber: 1,
      size: 10,
      currentProduct: undefined,
      currentCategory: 'all',
      currentFilter: 'all',
      productlist: [],
      categorylist: undefined,
      subcategorylist: undefined,
      currentSubCategory: 'all',
      selectedProduct: null,
      showCategory: false,
      showSubCategory: false,
      showModal: false,

      loadingProduct: true,
      loadingCategory: true,
      pagelimit: [10, 25, 50],

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      productCount: 0,

      search: '',
      state: 'list',
      timestamp: moment().format('x'),
      limit: 100,
      offset: 0
    }
  },
  components: {
    Product,
    ModalGift,
    ImportShop,
    GiftCategory,
    SelectCategory,
    ScaleLoader,
    FilterCategory,
    ModalHelp,
    TransferShop,
    SortProduct,
    GiftSubCategory
  },
  mounted: function () {
    let vm = this
    // vm.$store.dispatch("loading")
    vm.getCategories(function () {
      if (vm.categorylist.length > 0) {
        vm.onChangeCategory(vm.categorylist[0])
      }
      vm.getSubCategories()
      vm.getProducts().then(() => {
        vm.loadingCategory = false
      })
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      isFacebook: 'isFacebook'
    }),
    maxProduct() {
      return this.isCoachlab ? 20 : 10
    },
    filterProducts: function () {
      let products = []
      let vm = this
      vm.filterBadge = {
        all: vm.productlist.length
      }

      $.each(vm.productlist, function (index, val) {
        if (vm.currentCategory !== 'all') {
          if (vm.currentCategory === val.category_id) {
            products.push(val)
          } else if (vm.currentSubCategory === val.sub_category_id) {
            products.push(val)
          }
        }
      })

      if (vm.currentCategory === 'all') {
        products = vm.productlist
      }

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter((product) => {
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null && product.code.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    exportAkita() {
      var dataWS = null
      var json = this.productlist.map((product) => {
        var photourl = []
        try {
          if (product.photourl != '') photourl = product.photourl.split(';;')
        } catch (error) {}

        var variants = []

        try {
          variants = JSON.parse(product.productstockcategories)
        } catch (error) {}
        if (variants.length == 0) variants = [{ level: 0, name: 'ตัวเลือก' }]

        if (photourl.length == 0) {
          photourl[0] =
            'https://zwizai.s3.amazonaws.com/ecommerce/1583138880495image-not-found-big-300x169.png'
        }
        return product.productstock.map((stock) => {
          var stock_variants = []
          var price = 0

          if (stock[4]) {
            price = stock[4]
          } else if (stock[3]) {
            price = stock[3]
          } else if (product.discountprice) {
            price = product.discountprice
          } else {
            price = product.price
          }
          try {
            stock_variants = stock[1].split('/')
          } catch (error) {}
          return {
            code: product.code,
            name: product.name,
            description: product.description,
            variant1: variants[0].name,
            variant2: variants.length > 1 ? variants[1].name : '',
            brand: '',
            photo1: photourl[0],
            photo2: photourl[1] ? photourl[1] : '',
            photo3: photourl[2] ? photourl[2] : '',
            photo4: photourl[3] ? photourl[3] : '',
            photo5: photourl[4] ? photourl[4] : '',
            'sku.code': stock[5],
            'sku.barcode': '',
            'sku.variant1': stock_variants[0],
            'sku.variant2': stock_variants.length > 1 ? stock_variants[1] : '',
            'sku.cost': '',
            'sku.price': price
          }
        })
      })
      json = [].concat(...json)

      dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwiz-product.xlsx')
    },
    async close() {
      this.state = 'list'
      await this.$nextTick()
      goTo(0)
    },
    async onChangeProduct() {
      await this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeLimit: function (value) {
      this.size = value
      this.pageNumber = 1
      this.getProducts()
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      // this.offset = this.pageNumber * this.limit - this.limit
      // this.getProducts();
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onAddNewProduct: function () {
      var vm = this
      if (
        (vm.$store.getters.getPackage === 'premium' && !vm.isCoachlab) ||
        (vm.$store.getters.getPackage !== 'premium' && vm.productlist.length < vm.maxProduct) ||
        (vm.isCoachlab && vm.productlist.length < vm.maxProduct)
      ) {
        vm.state = 'add-product'
      }
      this.timestamp = moment().format('x')
    },
    closeEditProduct: async function () {
      var vm = this
      await vm.getProducts()
      // vm.$store.dispatch('loading')
      vm.state = 'list'
      this.timestamp = moment().format('x')
    },
    onSelectedProduct: function (index, product) {
      this.currentProduct = product
      this.state = 'edit-product'
    },
    onCategoryChange: function () {
      let vm = this
    },
    onSubCategoryChange: function () {
      let vm = this
    },
    deleteCategory(categoryid) {
      this.productlist = this.productlist.filter((el) => {
        return el.categoryid != categoryid
      })
      if (this.currentCategory == categoryid) {
        this.setDefaultCategory()
      }
    },
    deleteSubCategory(subcategoryid) {
      this.productlist = this.productlist.filter((el) => {
        return el.subcategoryid != subcategoryid
      })
      if (this.currentSubCategory == subcategoryid) {
        this.setDefaultSubCategory()
      }
    },
    getCategories: function (callback) {
      let vm = this
      vm.loadingCategory = true
      if (!vm.selectedBot) {
        return
      }
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }

      api.getLamyGiftCategory(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.categorylist = response.data
        if (callback) callback()
      })
    },
    getSubCategories: function (callback) {
      let vm = this
      vm.loadingSubCategory = true
      if (!vm.selectedBot) {
        return
      }

      var categoryId = ''
      if (vm.currentCategory !== 'all') {
        categoryId = vm.currentCategory
      }

      var data = {
        pageid: vm.selectedBot.pageid,
        category_id: categoryId,
        limit: vm.limit,
        offset: vm.offset
      }

      api.getLamyGiftSubCategory(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.subcategorylist = response.data
        vm.loadingSubCategory = false

        if (callback) callback()
      })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }

        var subCategoryId = ''
        if (vm.currentSubCategory !== 'all') {
          subCategoryId = vm.currentSubCategory
        } else {
          subCategoryId = ''
        }

        let data = {
          pageid: vm.selectedBot.pageid,
          sub_category_id: subCategoryId,
          limit: vm.limit,
          offset: vm.offset
        }
        vm.loadingProduct = true
        vm.productlist = []

        api.getLamyGiftProducts(data, function (error, response) {
          // console.log(response);
          if (error) {
            console.error(error)
            vm.loadingProduct = false
            resolve()
            return
          }

          vm.productlist = response.data
          vm.productCount = response.total
          vm.loadingProduct = false
          resolve()
        })
      })
    },
    async addProduct() {
      await this.getProducts()
      this.timestamp = moment().format('x')
    },
    onSelectProduct: function (val) {
      this.selectedProduct = this.productlist.find((product) => {
        return product.id == val
      })
    },
    onLoadCategory: function (payload) {
      // console.log(payload)
      if (payload && payload.length > 0) {
        // this.getProducts()
      }
    },
    onChangeCategory: function (payload) {
      this.setDefaultCategory()
      this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      // this.getProducts()
    },
    onChangeSubCategory: function (payload) {
      this.setDefaultSubCategory()
      this.currentFilter = 'all'
      this.search = ''
      this.pageNumber = 1
      // this.getProducts()
    },
    onDeleteProduct: function (index) {
      // vm.productlist.splice(index,1)
      this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeProductStatus(payload) {
      var index = this.productlist.findIndex((el) => {
        return payload.id == el.id
      })
      this.$set(this.productlist[index], 'status', payload.status)
    },
    setDefaultCategory() {
      if (this.selectedBot.theme == 'nvbb' && this.categorylist.length > 0) {
        this.currentCategory = this.categorylist[0].id
      } else {
        this.currentCategory = 'all'
      }
    },
    setDefaultSubCategory() {
      if (this.subcategorylist.length > 0) {
        this.currentSubCategory = this.subcategorylist[0].id
      } else {
        this.currentSubCategory = 'all'
      }
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    showCategory: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    showSubCategory: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    currentCategory: function (newVal, oldVal) {
      if (newVal != null) {
        this.pageNumber = 1
        this.currentSubCategory = ''
        this.getSubCategories(function () {})
        // this.getProducts(function() {})
      }
    },
    currentSubCategory: function (newVal, oldVal) {
      if (newVal != null) {
        this.pageNumber = 1
        this.getProducts(function () {})
      }
    },
    productlist: function (newVal, oldVal) {
      let vm = this
      // $.each(vm.productlist,function(index ,val){
      // 	if (val.categoryid != vm.currentCategory.id) {
      // 		vm.productlist.splice(index,1)
      // 		return false;
      // 	}
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.ketshop-bg-color {
  background-color: rgb(58, 58, 58);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/Gift.vue